import LoginMixRegisterBrick from './LoginMixRegisterBrick';
import FJAction from '../../action/FJAction';
import FJLocalStore from '../../store/FJLocalStore';
import { useDispatch, useSelector } from 'react-redux';

const LoginMinRegisterContainer = props => {
    const dispatch = useDispatch();
    const { email, stepChange } = useSelector(store => {
        return {
            email: store.mainStore.email,
        };
    });
    let { hasLogo, popupType } = props;
    // 邮件账号改变
    let _emailChange = curEmail => {
        // setEmail(curEmail)
        dispatch(FJAction.changeEmail(curEmail));
    };
    // 查看邮箱是否已注册
    let _checkEmail = callBack => {
        dispatch(FJAction.checkEmail({ code_language: FJLocalStore.currentTag(), email }, callBack));

        // 一下是绕过正常检测的测试代码
        // dispatch(FJAction.changeConfirmEmail(email))
        // dispatch(FJAction.changeStep('verifyEmailCode'))
        // return Promise.resolve({
        //   result: true,
        // })
    };

    // 发送谷歌验证成功后的 accessToken
    let _sendGoogleToken = accessToken => {
        dispatch(FJAction.sendGoogleTokenAction(accessToken));
    };
    // 发送facebook验证成功后的 accessToken
    let _sendFacebookToken = accessToken => {
        dispatch(FJAction.sendFacebookTokenAction(accessToken));
    };
    return (
        <LoginMixRegisterBrick
            value={email}
            onChange={_emailChange}
            continueClick={_checkEmail}
            stepChange={stepChange}
            hasLogo={hasLogo}
            popupType={popupType}
            active={true}
            sendGoogleToken={_sendGoogleToken}
            sendFacebookToken={_sendFacebookToken}
        />
    );
};
export default LoginMinRegisterContainer;
